import React from 'react'

export default function Badge({ result }) {
  if (!result || !result.dashboard) return null
  const { dashboard, activeTrade } = result

  const trendColor = dashboard.trend === 'Bullish' ? '#00E676' : dashboard.trend === 'Bearish' ? '#FF5252' : '#aaa'
  const signalColor = dashboard.signal === 'LONG' ? '#00E676' : dashboard.signal === 'SHORT' ? '#FF5252' : '#aaa'

  return (
    <div style={{
      position: 'absolute',
      top: 10,
      right: 10,
      background: 'rgba(19,23,34,0.9)',
      border: '1px solid #2A2E39',
      borderRadius: 4,
      padding: '8px 12px',
      fontSize: 12,
      color: '#E0E0E0',
      minWidth: 180,
      zIndex: 10,
    }}>
      <div style={{ fontWeight: 700, marginBottom: 6, color: trendColor }}>
        ◆ LSP · {dashboard.trend}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px' }}>
        <span style={{ color: '#9E9E9E' }}>Signal</span>
        <span style={{ color: signalColor, fontWeight: 600 }}>{dashboard.signal}</span>
        <span style={{ color: '#9E9E9E' }}>HTF Bias</span>
        <span>{dashboard.htfBias}</span>
        <span style={{ color: '#9E9E9E' }}>Last Sweep</span>
        <span>{dashboard.lastSweep}</span>
        {activeTrade && <>
          <span style={{ color: '#9E9E9E' }}>SL</span>
          <span>{dashboard.sl}</span>
          <span style={{ color: '#9E9E9E' }}>TP1</span>
          <span>{dashboard.tp1}</span>
          <span style={{ color: '#9E9E9E' }}>R:R</span>
          <span>{dashboard.rr}</span>
        </>}
        <span style={{ color: '#9E9E9E' }}>Trades</span>
        <span>{dashboard.wl} ({dashboard.winRate})</span>
      </div>
    </div>
  )
}
